"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialIdentityState = void 0;
/**
 * The initial auth state.
 */
exports.initialIdentityState = {
    isAuthenticated: false,
    isError: false,
    isLoading: true,
    status: "loading"
};
